import PropTypes from 'prop-types'
import { useAuth } from '../components/App/AuthProvider'
import { Navigate } from 'react-router-dom'
import useCurrentUserModulesSelector from '../api/selectors/useCurrentUserModulesSelector'
import { Suspense, useMemo } from 'react'
import BoxPageLoader from '@derolfgroep/ui-components/src/components/BoxPageLoader/BoxPageLoader'
import useCurrentUserIsAuthPersonTypes from '../api/selectors/useCurrentUserIsAuthPersonTypes'

const RequireAuth = ({ children, redirectPath = '/', module = null, personTypes = null }) => {
  const { isAuthenticated } = useAuth()
  const { modules, isLoading } = useCurrentUserModulesSelector()
  const hasModule = useMemo(() => modules?.includes(module), [module, modules])
  const isCurrentUserAuthorizedPersonTypes = useCurrentUserIsAuthPersonTypes(personTypes)

  if (isLoading) {
    return <BoxPageLoader />
  }

  if (
    isAuthenticated &&
    ((module && personTypes && isCurrentUserAuthorizedPersonTypes && hasModule) ||
      (!module && isCurrentUserAuthorizedPersonTypes) ||
      (!personTypes && hasModule))
  ) {
    return <Suspense fallback={<BoxPageLoader />}>{children}</Suspense>
  }

  return <Navigate to={redirectPath} />
}

RequireAuth.propTypes = {
  redirectPath: PropTypes.string,
  children: PropTypes.node.isRequired,
  module: PropTypes.string,
  personTypes: PropTypes.array,
}

export default RequireAuth
